<script setup lang="ts">
import { type UrlTabConfig } from "~/helpers/tabs-helpers";

const props = defineProps<{ items: UrlTabConfig[]; context: string; basePath: string; params?: Record<string, string> }>();

const t = useTranslator();

const route = useRoute();

const ampli = useAmplitude();

const itemsFiltered = computed(() => props.items.filter((t) => !t.disabled));

const activeTab = computed(() => (route.name as string)?.replace(props.basePath, "").replace(/^-/, ""));
const activeTabLabel = computed(() => {
  const tab = itemsFiltered.value.find((t) => t.tabKey === activeTab.value);
  return tab ? t(tab.labelKey) : "";
});
const getNavigateToName = (tab: UrlTabConfig) => (tab.tabKey != "" ? `${props.basePath}-${tab.tabKey}` : props.basePath);

usePageTitle({ position: 2, title: activeTabLabel });

const setActiveTab = async (tab: UrlTabConfig, replace?: boolean) => {
  const properties = {
    hierarchy: props.context,
    page: tab.tabKey,
  };

  ampli.navigateToTab(properties);

  navigateTo({
    name: getNavigateToName(tab),
    params: props.params,
    query: tab.query,
    replace,
  });
};

watch(
  activeTab,
  (v) => {
    let defaultTab: UrlTabConfig | undefined = undefined;

    if (!v && (defaultTab = itemsFiltered.value.find((t) => !!t.default))) setActiveTab(defaultTab, true);
  },
  { immediate: true }
);
</script>
<template>
  <TabBox
    colorBackground="--color-white"
    colorBackgroundActive="--color-primary"
    colorBackgroundHover="--color-primary"
    colorLabelActive="--color-white"
    colorLabelInactive="--color-primary"
    colorScrollForeground="--color-accent-200"
    colorScrollBackground="--color-accent-600"
    v2activeMode
  >
    <template #items>
      <NuxtLink
        v-for="tab in itemsFiltered"
        :key="tab.tabKey"
        :to="{
          name: getNavigateToName(tab),
          params: props.params,
          query: tab.query,
        }"
      >
        <TabBoxItem :active="activeTab === tab.tabKey" :label="t(tab.labelKey)" />
      </NuxtLink>
    </template>
  </TabBox>
</template>
